export type FootprintMode = 'edit' | 'draw' | 'scale' | 'image';

export function resolveActiveFootprintMode(
  isFootprintStep: boolean,
  footprintMode: FootprintMode
): FootprintMode | undefined {
  return isFootprintStep ? footprintMode : undefined;
}

export function resolveFootprintModeAfterShapeCountChange(
  previousCount: number,
  nextCount: number,
  currentMode: FootprintMode
): FootprintMode {
  if (previousCount > 0 && nextCount === 0) {
    return 'draw';
  }
  return currentMode;
}
